// extracted by mini-css-extract-plugin
export var image = "dj_c5";